import SocialMedia from "components/About/SocialMedia";
import HeroBusinessConsulting from "components/BusinessConsulting/HeroBusinessConsulting";
import ListBusinessConsulting from "components/BusinessConsulting/ListBusinessConsulting";
import MissionBusinessConsulting from "components/BusinessConsulting/MissionBusinessConsulting";
import QuoteBusinessConsulting from "components/BusinessConsulting/QuoteBusinessConsulting";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import PriceSection from "components/Service/PriceSection";
import BookSection from "components/Events/BookSection";

import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BusinessConsulting = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");

      setTimeout(() => {
        const element = document.getElementById(id);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location]);
  return (
    <div>
      {/* <HeroBusinessConsulting /> */}
      <MissionBusinessConsulting />
      <QuoteBusinessConsulting />
      <div id="businessconsulting">
        <ListBusinessConsulting />
      </div>
      {/* <PriceSection /> */}
      <BookSection />
    </div>
  );
};

export default BusinessConsulting;
